import $ from 'jquery';

$(function () {
  // Check for hash in url and if it contains the word 'accordion', it true, scroll to and open
  if (window.location.hash) {
    const hash = window.location.hash;
    if (document.querySelector(hash) && hash.includes('accordion')) {
      $([document.documentElement, document.body]).animate(
        {
          scrollTop: $(hash).offset().top - 300
        },
        2000
      );
      $(hash).addClass('toggle__switch--on');
      $(hash).next().addClass('toggle__target--visible');
    }
  }

  // Image Dropdown Cards Accordion
  if ($('.image__dropdown__cards.section .card').length > 0) {
    // close all other accordions
    $('.image__dropdown__cards .container').on('mouseleave', function () {
      $('.image__dropdown__cards.section .card')
        .find('.toggle__target')
        .removeClass('toggle__target--visible');

      $('.image__dropdown__cards.section .card')
        .find('.toggle__switch')
        .removeClass('toggle__switch--on');
    });

    $('.image__dropdown__cards.section .card').each(function () {
      const $this = $(this);
      const $toggle = $this.find('.toggle__switch');
      const $target = $this.find('.toggle__target');

      $toggle.on('mouseover', function () {
        // close all other accordions
        $('.image__dropdown__cards.section .card')
          .not($this)
          .find('.toggle__target')
          .removeClass('toggle__target--visible');

        $('.image__dropdown__cards.section .card')
          .not($this)
          .find('.toggle__switch')
          .removeClass('toggle__switch--on');

        // open this accordion on hover
        $target.addClass('toggle__target--visible');
        $toggle.addClass('toggle__switch--on');
      });
    });
  }
});
